import {
  Button,
  Divider,
  IconAdd,
  rem,
  SpaceBetween,
  spacing,
  styled,
  TextField,
  UploadFileInput,
  useForm,
} from '@lessonup/ui-components';
import { TFunction } from 'i18next';
import React from 'react';
import { HandleAddImage } from '../ImagePickerModal.types';

interface UploadImageTabProps {
  acceptMultipleFiles?: boolean;
  handleAddImage: HandleAddImage;
  t: TFunction;
}

interface AddImageFromLinkFormInput {
  url: string;
}

export const UploadImageTab: React.FC<UploadImageTabProps> = ({ acceptMultipleFiles = false, handleAddImage, t }) => {
  const { register, getValues, watch } = useForm<AddImageFromLinkFormInput>();
  const urlInput = watch('url');

  const handleUploadFromInput = async (files: File[]) => {
    if (!files.length) return;
    handleAddImage({ files, source: 'upload' });
  };

  return (
    <SpaceBetween spacing={spacing.size8} direction="y" alignItems="center">
      <StyledTextField
        {...register('url')}
        type="url"
        size="small"
        placeholder={t('imagePicker.urlInputPlaceholder')}
        label={t('imagePicker.linkLabel')}
        autoComplete="off"
        endSlot={
          <Button
            size="small"
            buttonType="neutral"
            showStroke
            onClick={() => handleAddImage({ urls: [getValues().url], source: 'pasteUrl' })}
            type="submit"
            buttonShape="rect"
            disabled={!urlInput}
          >
            {t('imagePicker.addButton')}
          </Button>
        }
      />
      <DividerWrapper>
        <Divider orientation="horizontal" text={t('imagePicker.linkDivider')} />
      </DividerWrapper>
      <UploadFileInput
        buttonType="secondary"
        icon={<IconAdd />}
        buttonShape="rect"
        buttonSize="small"
        acceptedMimeTypes={{
          audioTypes: [],
          documentTypes: [],
          imageTypes: ['image/jpeg', 'image/gif', 'image/bmp', 'image/png', 'image/tiff', 'image/webp'],
          videoTypes: [],
        }}
        multiple={acceptMultipleFiles}
        onUpload={handleUploadFromInput}
      >
        {t('imagePicker.uploadButton')}
      </UploadFileInput>
    </SpaceBetween>
  );
};

const DividerWrapper = styled.div`
  width: ${rem('64px')};
  margin: 0 auto;
`;

const StyledTextField = styled(TextField)`
  width: 100%;
  max-width: ${rem('400px')};
`;
